module.exports = __webpack_public_path__ + "static/ufo_img1-56f807d3ac22da63d70f2f8545bfdc06.png";